// 只用 DOM API 构建节点,不拼接 HTML,所有文本都走 textContent

export type Child = Node | string | null | undefined | false;
export type Attrs = Record<string, string | boolean | number | EventListener | undefined>;

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Attrs = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === undefined || v === false) continue;
    if (k.startsWith('on') && typeof v === 'function') el.addEventListener(k.slice(2), v);
    else if (k === 'class') el.className = String(v);
    else if (k in el && k !== 'list') (el as unknown as Record<string, unknown>)[k] = v;
    else el.setAttribute(k, v === true ? '' : String(v));
  }
  for (const c of children) if (c) el.append(c);
  return el;
}

export const $ = <T extends HTMLElement>(sel: string) => document.querySelector(sel) as T;

export function toast(msg: string, kind: 'ok' | 'err' = 'ok') {
  const t = h('div', { class: `toast ${kind}`, role: 'status' }, msg);
  document.body.append(t);
  setTimeout(() => t.remove(), 3200);
}

export function select<T extends string>(value: T, options: [T, string][], onPick: (v: T) => void, cls?: string): HTMLSelectElement {
  const s = h('select', { class: cls, onchange: (e: Event) => onPick((e.target as HTMLSelectElement).value as T) });
  for (const [v, label] of options) s.append(h('option', { value: v, selected: v === value }, label));
  return s;
}

export function checkbox(checked: boolean, label: string, onToggle: (on: boolean) => void, hint?: string): HTMLLabelElement {
  return h(
    'label',
    { class: 'chip' },
    h('input', { type: 'checkbox', checked, onchange: (e: Event) => onToggle((e.target as HTMLInputElement).checked) }),
    h('span', { class: 'chip-label' }, label),
    hint ? h('small', {}, hint) : null,
  );
}

export const compact = <T>(xs: (T | null | undefined | false)[]): T[] => xs.filter((x): x is T => !!x);
